import { createSlice } from '@reduxjs/toolkit';

interface IAuthState {
	loading: boolean;
	error: string | null;
	token: any;
}

const initialState: IAuthState = {
	loading: false,
	error: null,
	token: localStorage.getItem('bo_token'),
};

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setToken: (state, { payload }) => {
			state.error = null;
			localStorage.setItem('bo_token', payload);
			state.token = payload;
		},
		clearToken: (state) => {
			localStorage.removeItem('bo_token');
			state.token = null;
		},
		setLoading: (state, { payload }) => {
			state.loading = payload;
		},
		setError: (state, { payload }) => {
			state.error = payload;
		},
	},
});

export const getError = (state: any) => {
	return state.auth.error;
};

export const isLoading = (state: any) => state.auth.loading;

export const getToken = (state: any) => state.auth.token;

export const { setToken, setLoading, setError, clearToken } = authSlice.actions;

export default authSlice.reducer;
